import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Set this to `true` on individual requests that should be GZip-compressed.
 * All other requests are sent as-is.
 */
export const GZIP_REQUEST = new HttpContextToken<boolean>(() => false);


export function withGzipHandling(context: HttpContext = new HttpContext()): HttpContext {
    return context.set(GZIP_REQUEST, true);
}
